import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalCloseButton, useDisclosure, Text, Tooltip } from '@chakra-ui/react'
import * as T from '../../../../components/Table'
import { useMemo } from 'react'
import { format } from 'date-fns'

export function HistoricoTroca({ qtdTrocas, historico = [] }) {
  const { isOpen, onOpen, onClose } = useDisclosure()

  const data = useMemo(() => {
    return historico.map((item) => {
      return {
        ...item,
        troca_solicita: item.troca_solicita ? format(new Date(item.troca_solicita), 'dd/MM/yyyy HH:mm') : 'Sem data',
        recebimento_troca: item.recebimento_troca ? format(new Date(item.recebimento_troca), 'dd/MM/yyyy HH:mm') : 'Sem data',
        troca_compras: item.troca_compras ? format(new Date(item.troca_compras), 'dd/MM/yyyy HH:mm') : 'Sem data',
      }
    })
  }, [historico])

  return (
    <>
      <Text cursor="pointer" textDecoration="underline" onClick={() => onOpen()} color={qtdTrocas > 1 && 'red.500'}>
        {qtdTrocas && qtdTrocas}x
      </Text>

      <Modal isOpen={isOpen} onClose={onClose} size="4xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Histórico de Trocas ({qtdTrocas})</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <T.Table>
              <T.Thead>
                <T.Tr>
                  <T.Th>Troca solicitada</T.Th>
                  <T.Th>Qtd. Troca</T.Th>
                  <T.Th>Troca compras</T.Th>
                  <T.Th>Num Solicitação</T.Th>
                  <T.Th>Recebimento troca</T.Th>
                  <T.Th>Obs Troca</T.Th>
                </T.Tr>
              </T.Thead>
              <T.Tbody>
                {data.map((item, index) => (
                  <T.Tr key={index}>
                    <T.Td>{item.troca_solicita}</T.Td>
                    <T.Td>{item.quantidade_troca}</T.Td>
                    <T.Td>{item.troca_compras}</T.Td>
                    <T.Td>{item.ordem_troca}</T.Td>
                    <T.Td>{item.recebimento_troca}</T.Td>
                    <T.Td>
                      <Tooltip label={item.obs_troca}>{item.obs_troca?.substring(0, 12).concat('...')}</Tooltip>
                    </T.Td>
                  </T.Tr>
                ))}
              </T.Tbody>
            </T.Table>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  )
}
